// ADE App - Complete i18n Translations
const translations = {
  it: {
    // ADE Missions
    missionLabel: "ADE MISSION", missionSponsored: "SPONSORIZZATA", missionScheduled: "PROGRAMMATA",
    missionStep1: "Vai al locale", missionStep2: "Resta almeno", missionStep3: "Ricevi la ricompensa",
    missionDiscover: "SCOPRI", missionInterested: "INTERESSATO", missionWillNotify: "TI AVVISEREMO",
    missionRemoveInterest: "Rimuovi interesse", missionAccept: "ACCETTA MISSIONE",
    missionDwellLabel: "Permanenza", missionFromYou: "da te", missionReward: "Reward",
    missionFull: "Mission esaurita", missionSlotsLeft: "ricompense disponibili", missionLimited: "Disponibilità limitata",
    missionVisitStore: "Visita il punto vendita", missionStayAtLeast: "Rimani almeno",
    missionNotStarted: "La Mission non è ancora iniziata", missionGoToStore: "Raggiungi il punto vendita",
    missionVerifiedDwell: "Permanenza verificata", missionVerifyInterrupted: "Verifica della posizione interrotta",
    missionVerifyResuming: "Ripresa automatica in corso…", missionStayInStore: "Rimani nel punto vendita per almeno",
    missionMinutes: "minuti", missionCompleted: "Mission completata!", missionInReview: "Visita in verifica",
    missionInReviewDesc: "La tua visita è in fase di verifica. Riceverai una notifica appena completata.",
    missionRewarded: "Hai ricevuto", missionCancel: "Abbandona Mission", missionCancelled: "Mission abbandonata",
    missionHistory: "Le mie Mission", missionActive: "Mission attiva", missionNoHistory: "Nessuna Mission completata",
    missionOutside: "Sei fuori dall'area del punto vendita", missionInside: "Sei nel punto vendita",
    missionActivateTitle: "Attiva ADE Missions", missionActivateDesc: "Completa il profilo e accetta i consensi per partecipare alle Mission.",
    missionFirstName: "Nome", missionLastName: "Cognome", missionDob: "Data di nascita",
    missionResidenceCity: "Città di residenza", missionLocationConsent: "Acconsento alla verifica della posizione durante le Mission attive (solo ad app aperta)",
    missionPersonalizationConsent: "Acconsento a suggerimenti Mission personalizzati (facoltativo)",
    missionTermsConsent: "Accetto i termini ADE Missions",
    missionActivateCta: "Attiva Missions", missionActivated: "ADE Missions attivato!",
    missionGpsNeeded: "Attiva il GPS per verificare la visita", missionExpired: "Mission scaduta",
    missionErrorGeneric: "Errore, riprova", missionStatusScheduledAt: "Inizia",
    missionDiscoverCta: "Scopri la Mission", missionArrived: "Sei arrivato!",
    missionStayToComplete: "Rimani nel punto vendita per completare la Mission",
    missionPresenceVerified: "Presenza verificata", missionReach: "RAGGIUNGI IL PUNTO VENDITA",
    missionVerifying: "Stiamo verificando la tua visita…", missionVerifiedDwellRow: "Permanenza verificata",
    missionRewardIncoming: "Reward in arrivo", missionVerifiedBang: "Mission verificata!",
    missionGoWallet: "Vai al Wallet", missionActiveHeader: "MISSION ATTIVA",
    missionStepAccepted: "Accettata", missionStepTraveling: "In viaggio",
    missionStepInStore: "Nel negozio", missionStepVerified: "Verificata",
    missionCoinsName: "ADE Coins",
    deleteMessageTitle: "Elimina messaggio", deleteForMe: "Elimina per me", deleteForEveryone: "Elimina per tutti",
    deletedTombstone: "Messaggio eliminato", deleteConversation: "Elimina conversazione",
    deleteConversationDesc: "La conversazione verrà eliminata solo per te. L'altra persona continuerà a vedere la propria cronologia.",
    conversationDeleted: "Conversazione eliminata", cancelAction: "Annulla",
    regCreated: "Account creato! Verifica la tua email.", regFillRequired: "Compila tutti i campi obbligatori",
    regAcceptConsents: "Devi accettare tutti i consensi obbligatori",
    regMinAge: "Devi avere almeno 16 anni per usare ADE", regError: "Errore durante la registrazione",
    giftEarnings: "Guadagni da regali",
    phName: "Il tuo nome *", phEmail: "Email *", phPassword: "Password *", phUsername: "Username (facoltativo)",
    dobLabel: "Data di nascita *",
    earningsPendingTitle: "Guadagni in attesa",
    earningsPendingDesc: "Guadagni in attesa – completa l'attivazione Creator per renderli disponibili",
    activateEarnings: "Attiva i guadagni",
    earningsAvailableTitle: "Guadagni disponibili",
    earningsPaidTitle: "Pagato",
    creatorPendingReview: "Richiesta Creator in revisione",
    creatorPendingReviewDesc: "La tua richiesta è in fase di verifica. I guadagni restano in attesa fino all'approvazione.",
    creatorRejectedTitle: "Richiesta Creator rifiutata",
    creatorRetry: "Invia nuova richiesta",
    earningsHoldInfo: "I Rewards diventano disponibili 14 giorni dopo la generazione",
    earningsNotSpendable: "Non spendibile, trasferibile o prelevabile finché non attivi il profilo Creator",
    earningsSeparateNote: "I Guadagni Creator (EUR) sono separati dai Crediti ADE",
    earningsLoadError: "Impossibile caricare i guadagni",
    retryBtn: "Riprova",
    cropOriginal: "Originale",
    cropVertical: "Verticale",
    cropHorizontal: "Orizzontale",
    hubExploreDesc: "Scopri persone e luoghi intorno a te",
    hubMessagesDesc: "Chatta con le tue connessioni",
    hubCreditsDesc: "Gestisci il tuo saldo e movimenti",
    hubGiftsDesc: "Invia e ricevi regali esclusivi",
    hubGoldenRingDesc: "Accedi a privilegi e vantaggi esclusivi",
    hubCreatorDesc: "Strumenti per creator e professionisti",
    hubSettingsDesc: "Personalizza la tua esperienza ADE",
    storyReplyYou: "Hai risposto al suo mood",
    storyReplyToYours: "Ha risposto al tuo mood",
    forgotPasswordLink: "Password dimenticata?",
    forgotPasswordTitle: "Recupera password",
    forgotPasswordDesc: "Ti invieremo una password provvisoria via email. Dopo l'accesso dovrai impostarne una nuova.",
    tempPwdSent: "Se l'email è registrata, riceverai una password provvisoria",
    changePasswordTitle: "Cambia password",
    changePasswordSubtitle: "Aggiorna la password del tuo account",
    currentPwd: "Password attuale",
    tempPwdLabel: "Password provvisoria",
    newPwd: "Nuova password",
    confirmPwd: "Conferma nuova password",
    confirmPasswordPh: "Conferma password",
    pwdMismatch: "Le password non coincidono",
    pwdChanged: "Password aggiornata!",
    forcedChangeNote: "Hai effettuato l'accesso con una password provvisoria: imposta subito una nuova password.",
    callHistoryTitle: "Chiamate",
    callMissed: "Persa",
    callIncoming: "Ricevuta",
    callOutgoing: "Effettuata",
    callNoAnswer: "Senza risposta",
    noCallsYet: "Nessuna chiamata ancora",
    newCall: "Nuova chiamata",
    audioCall: "Audio",
    // === NAV ===
    navNow: "Now",
    navHere: "Here",
    navAlerts: "Alerts",
    navMe: "Me",
    navMessages: "Messaggi",

    // === MESSAGES ===
    messagesTitle: "Messaggi",
    e2eProtected: "Protette da crittografia end-to-end",
    noConversations: "Nessuna conversazione",
    noConversationsHint: "Connettiti con qualcuno e inizia a chattare",
    encryptedMessage: "Messaggio cifrato",
    justNow: "adesso",
    chatPlaceholder: "Scrivi un messaggio…",
    chatEmptyState: "Nessun messaggio. Inizia la conversazione!",
    notDecryptable: "Non decifrabile su questo dispositivo",
    e2eRestoreTitle: "Ripristina messaggi cifrati",
    e2eRestoreHint: "Nuovo dispositivo? Inserisci la tua password per ripristinare la chiave di crittografia e leggere i tuoi messaggi.",
    e2eRestoreBtn: "Ripristina",
    e2eRestoreWrongPass: "Password errata o backup non valido",
    e2eRestored: "Crittografia ripristinata!",
    messageDeleted: "Messaggio eliminato",
    messageDeleteError: "Errore nell'eliminazione",
    statusRead: "Letto",
    statusDelivered: "Consegnato",
    e2eActive: "Crittografia end-to-end",
    e2eUnavailable: "Crittografia non disponibile",
    youPrefix: "Tu: ",
    saveError: "Errore nel salvataggio",

    // === CHIAMATE ===
    callStarting: "Avvio chiamata…",
    callRinging: "Sta squillando…",
    callConnecting: "Connessione…",
    callEndedLabel: "Chiamata terminata",
    callMicError: "Microfono non disponibile",
    callFailed: "Impossibile avviare la chiamata",
    callMicHint: "Consenti l'accesso al microfono: su iPhone vai in Impostazioni → AdE → Microfono",
    callE2E: "Chiamata cifrata end-to-end",
    callIncomingLabel: "Chiamata audio in arrivo…",
    callAccept: "Accetta",
    callDecline: "Rifiuta",
    callOutgoingLog: "Chiamata effettuata",
    callIncomingLog: "Chiamata ricevuta",
    callMissedLog: "Chiamata persa",
    callDeclinedLog: "Chiamata rifiutata",

    // === GIFT PICKER ===
    giftPickerTitle: "Invia un Gift",
    giftSendBtn: "Invia Gift",
    giftSending: "Invio...",

    // === PRIVACY SETTINGS ===
    readReceiptsLabel: "Conferme di lettura",
    readReceiptsDesc: "Se disattivato, gli altri non vedranno quando hai letto i loro messaggi",
    hideIdentityLabel: "Nascondi identità nei collegamenti isola",
    hideIdentityDesc: "Anche dopo il collegamento, gli altri vedranno solo il tuo Nome Isola: nome reale, foto e dettagli restano nascosti",

    // === PAGINE VARIE ===
    imgUnavailable: "Immagine non disponibile",
    noConnectionsShort: "Nessun collegamento",
    connectToShare: "Collegati con qualcuno per condividere",
    newPost: "Nuovo post",
    noDescription: "Nessuna descrizione",
    publicProfile: "Profilo pubblico",
    privateProfile: "Profilo privato",
    theirIsland: "La sua isola",
    noPostsYet: "Nessun post ancora",
    noGiftsReceived: "Nessun regalo ricevuto",
    reportUser: "Segnala utente",
    reportReason: "Seleziona il motivo della segnalazione",
    aloneOnIsland: "Sei solo sull'isola",
    enableGpsHint: "Attiva il GPS per trovare persone nel mondo reale!",
    castaway: "Naufrago su ADE Island",
    adeWorld: "Mondo ADE",
    loadingMap: "Caricamento mappa...",
    wantsToConnect: "Vuole collegarsi",
    newConnections: "Nuove connessioni",
    noConnectionYet: "Nessuna connessione",
    requestsAppearHere: "Le richieste e le connessioni appariranno qui",
    noTagFound: "Nessun AdETag trovato",
    noTagYet: "Nessun AdETag ancora",
    adeCredits: "Crediti ADE",
    availableBalance: "Saldo disponibile",
    noTransactions: "Nessuna transazione",
    transactionsAppearHere: "Le tue operazioni appariranno qui",
    noGiftsReceivedYet: "Non hai ancora ricevuto Gift",
    giftsReceivedLabel: "Gift ricevuti",
    noGiftsSentYet: "Non hai ancora inviato Gift",
    sendFirstGift: "Invia il tuo primo regalo!",
    showGiftsOnProfile: "Mostra Gift sul profilo",
    othersSeeGifts: "Gli altri vedono i Gift che hai ricevuto",
    pendingResponse: "In attesa di risposta...",
    noPendingRequests: "Nessuna richiesta in attesa",
    noRecentHistory: "Nessuna cronologia recente",
    resolvedConnectionsHint: "Le connessioni risolte appaiono qui per 24h",
    giftCenterSub: "I regali che hai inviato e ricevuto su ADE",
    giftsReceivedAppearHere: "I regali ricevuti appariranno qui",
    tabReceived: "Ricevuti",
    tabSent: "Inviati",

    // === CREATOR / ADE+ ===
    taxData: "Dati Fiscali",
    personalData: "Dati Personali",
    requestPayout: "Richiedi Payout",
    noPayoutsYet: "Nessun payout ancora",
    becomeCreator: "Diventa Creator ADE",
    pointsToRedeem: "Punti da riscattare",
    requestPending: "Richiesta in attesa",
    requestRejected: "Richiesta respinta",
    cannotRequestPayout: "Non puoi richiedere il payout",
    naturalPerson: "Persona fisica",
    soleProprietor: "Ditta individuale",
    confirmData: "Conferma Dati",
    creatorProfile: "Profilo Creator",
    availableEarnings: "Guadagni disponibili",
    pendingLabel: "In attesa",
    txAppearOnGifts: "Le transazioni appariranno quando riceverai Gift",
    noCreatorTx: "Nessuna transazione Creator ancora",
    manageCreatorEarnings: "Gestisci i tuoi Creator Rewards",
    totalRewards: "Totale Reward",
    accessUnavailable: "Accesso non disponibile",
    cookieText: "ADE utilizza esclusivamente cookie tecnici necessari per il funzionamento dell'app. Non utilizziamo cookie di profilazione.",
    cookieAccept: "Accetta",
    cookieNecessary: "Solo necessari",
    step1of2: "Passaggio 1 di 2",
    createAccountCaps: "CREA ACCOUNT",
    continueWithGoogle: "Continua con Google",
    continueWithApple: "Continua con Apple",
    orLabel: "oppure",
    usernameHint: "3-20 caratteri, lettere, numeri, underscore",
    pwdMinHint: "Minimo 6 caratteri",
    minAgeHint: "Devi avere almeno 16 anni (GDPR Art. 8)",
    alreadyAccount: "Hai già un account?",

    // === ADE HUB ===
    hubTitle: "Menu ADE",
    hubSubtitle: "Tutte le funzionalità di ADE",
    hubExplore: "Esplora",
    hubMessages: "Messaggi",
    hubCredits: "Crediti",
    hubGifts: "Gift",
    hubGoldenRing: "Golden Ring",
    participate: "Partecipa",
    seeAll: "Vedi tutti i",
    replySingular: "risposta",
    participantSingular: "partecipante",
    discTitlePh: "Titolo",
    discOpeningPh: "Messaggio iniziale",
    publishDiscussion: "PUBBLICA DISCUSSION",
    discussionShared: "Discussion condivisa!",
    postShared: "Post condiviso!",
    commentsTxt: "commenti",
    publishAction: "Pubblica",
    shareAction: "Condividi",
    saveAction: "Salva",
    linkCopied: "Link copiato",
    timeNow: "ora",
    timeDayUnit: "g",
    pinnedInHere: "Discussion seguita: in cima al tuo HERE",
    doneTxt: "Fatto",
    reportSent: "Segnalazione inviata",
    participants: "partecipanti",
    repliesTxt: "risposte",
    newInterventions: "nuovi interventi",
    discussionClosed: "Discussion conclusa",
    participateComposer: "Partecipa alla Discussion…",
    followTxt: "Segui",
    muteTxt: "Silenzia",
    unmuteTxt: "Riattiva notifiche",
    abandonTxt: "Abbandona",
    reportTxt: "Segnala",
    closeDiscussion: "Chiudi Discussion",
    deleteDiscussion: "Elimina Discussion",
    newDiscussion: "Nuova Discussion",
    hubCreator: "Creator",
    hubSettings: "Impostazioni",

    // === LANDING ===
    hereNow: "Here, Now.",
    enter: "Entra",
    createAccount: "Crea account",

    // === LOGIN ===
    welcomeBack: "Bentornato",
    loginSubtitle: "Accedi per continuare",
    continueWithGoogle: "Continua con Google",
    continueWithApple: "Continua con Apple",
    or: "oppure",
    email: "Email",
    password: "Password",
    loginWithEmail: "Accedi con Email",
    noAccount: "Non hai un account?",
    register: "Registrati",

    // === REGISTER ===
    createAccountTitle: "CREA ACCOUNT",
    yourName: "Il tuo nome *",
    usernameOptional: "Username (opzionale)",
    usernameHint: "3-20 caratteri, lettere, numeri, underscore",
    selectCountry: "Seleziona Paese",
    passwordHint: "Minimo 6 caratteri",
    continue: "Continua",
    haveAccount: "Hai già un account?",
    login: "Accedi",
    step1of2: "Passaggio 1 di 2",
    step2of2: "Passaggio 2 di 2",
    privacyConsents: "Privacy & Consensi",
    privacyConsentsDesc: "Per utilizzare ADE devi accettare i seguenti consensi",
    termsAndConditions: "Termini e Condizioni *",
    termsAcceptText: "Accetto i termini di utilizzo del servizio ADE",
    readTerms: "Leggi i Termini e Condizioni",
    privacyPolicy: "Privacy Policy *",
    privacyAcceptText: "Acconsento al trattamento dei miei dati personali secondo GDPR",
    readPrivacy: "Leggi l'Informativa Privacy",
    geolocation: "Geolocalizzazione *",
    geoAcceptText: "Acconsento alla raccolta e utilizzo della mia posizione GPS",
    moreInfo: "Maggiori informazioni",
    marketingComms: "Comunicazioni Marketing",
    optional: "opzionale",
    marketingAcceptText: "Voglio ricevere novità, offerte e aggiornamenti su ADE",
    requiredConsent: "* Consenso obbligatorio per utilizzare ADE",
    creating: "Creazione...",
    acceptTerms: "Accetto i Termini",
    acceptPrivacy: "Accetto la Privacy Policy",
    acceptGeo: "Acconsento alla Geolocalizzazione",
    getStarted: "Get Started",
    alreadyHaveAccount: "Already have an account?",
    signIn: "Sign In",
    verified: "Verified",
    realTime: "Real-time",
    connectWithPeople: "Connect with interesting people\naround you in real time.",
    fillAllFields: "Compila tutti i campi obbligatori",
    passwordMinLength: "La password deve avere almeno 6 caratteri",
    usernameFormatError: "Username: 3-20 caratteri, solo lettere, numeri, underscore",
    mustAcceptConsents: "Devi accettare tutti i consensi obbligatori",
    accountCreated: "Account creato! Verifica la tua email.",
    registrationError: "Errore nella registrazione",

    // === VERIFY EMAIL ===
    verifyYourEmail: "Verifica la tua email",
    enterOtp: "Inserisci il codice a 6 cifre inviato a",
    enterOtpGeneric: "Inserisci il codice a 6 cifre per verificare la tua email",
    testMode: "Modalita test",
    testModeDesc: "In produzione il codice arrivera via email. Per ora usa:",
    verifyEmail: "Verifica Email",
    verifying: "Verifica...",
    enterFullCode: "Inserisci il codice completo a 6 cifre",
    invalidCode: "Codice non valido",
    emailVerified: "Email verificata!",
    redirecting: "Reindirizzamento...",
    resendIn: "Reinvia tra",
    didntReceiveCode: "Non hai ricevuto il codice? Reinvia",
    newCodeSent: "Nuovo codice inviato!",
    testCode: "Codice test:",
    sendError: "Errore nell'invio",

    // === HOME / FEED ===
    mood: "Mood",
    startSharing: "Inizia a condividere",
    publishFirstPhoto: "Pubblica la tua prima foto o collegati con qualcuno",
    publishPhoto: "Pubblica foto",
    feedError: "Errore nel caricamento",
    saveError: "Errore nel salvataggio",
    shareError: "Errore nella condivisione",
    now: "ora",
    minutesAgo: "min fa",
    hoursAgo: "h fa",
    daysAgo: "g fa",
    share: "Condividi",
    saveTxt: "Salva",
    comments: "commenti",
    writeComment: "Scrivi un commento...",
    send: "Invia",
    cropPhoto: "Ritaglia foto",
    publishing: "Pubblicando...",
    publish: "Pubblica",
    updateError: "Errore nell'aggiornamento",
    addCaption: "Aggiungi una descrizione...",
    deletePhoto: "Elimina foto",
    editCaption: "Modifica descrizione",
    adeLike: "AdE Like",

    // === HERE PAGE ===
    here: "Here",
    discoverNearby: "SCOPRI CHI È VICINO",
    gpsNotActive: "GPS non attivo",
    gpsActivateMsg: "Attiva il GPS per trovare persone vicine a te",
    activateGps: "Attiva GPS",
    peopleNearby: "persone nelle vicinanze",
    personNearby: "persona nelle vicinanze",
    noOneNearby: "Nessuno nelle vicinanze",
    noOneNearbyMsg: "Attiva il GPS e avvicinati ad altre persone per scoprirle",
    connect: "Collegati",
    cancelRequest: "Annulla",
    accept: "Accetta",
    decline: "Rifiuta",
    requestSent: "Richiesta inviata",
    connectionEstablishedMsg: "Collegamento stabilito!",
    message: "Messaggio",
    onAdeIsland: "Su ADE Island",
    adeIslandWelcome: "Benvenuto su ADE Island!",
    adeIslandMsg: "Non hai il GPS attivo, sei stato posizionato su ADE Island dove puoi incontrare altri utenti.",
    requestSentToast: "Richiesta inviata!",
    requestCancelled: "Richiesta annullata",
    requestAccepted: "Richiesta accettata!",
    requestDeclined: "Richiesta rifiutata",
    requestError: "Errore nella richiesta",
    cancelError: "Errore nell'annullamento",

    // === HERE - ISLAND TAB ===
    myIsland: "La mia isola",
    islandShareMsg: "Condividi il nome della tua isola per farti trovare su ADE Island!",
    copy: "Copia",
    copiedToClipboard: "Copiato!",
    worldMap: "Mappa Mondo",
    searchIslandPlaceholder: "Cerca un'isola...",

    // === HERE - REQUESTS TAB ===
    pendingRequests: "Richieste in arrivo",
    sentRequestsTitle: "Richieste inviate",
    recentHistory: "Cronologia recente",
    noPendingRequests: "Nessuna richiesta in arrivo",
    noSentRequests: "Nessuna richiesta inviata",
    noRecentHistory: "Nessuna attività recente",
    accepted: "Accettata",
    declined: "Rifiutata",

    // === HERE - CONNECTED TAB ===
    yourConnections: "I tuoi collegamenti",
    noConnections: "Nessun collegamento ancora",
    noConnectionsMsg: "Collegati con le persone che incontri!",
    removeConnection: "Rimuovi collegamento",
    connectionRemoved: "Collegamento rimosso",
    removeError: "Errore nella rimozione",

    // === PROFILE ===
    post: "Post",
    posts: "Post",
    connectionsTxt: "Collegamenti",
    adeLikes: "AdE Likes",
    editProfile: "Modifica profilo",
    addPhotoBtn: "+ Aggiungi",
    noPostsYet: "Nessun post ancora",
    publishFirstPhotoLink: "Pubblica la prima foto",
    profileError: "Errore nel caricamento del profilo",
    profilePicUpdated: "Foto profilo aggiornata",
    coverUpdated: "Copertina aggiornata",
    uploadError: "Errore nel caricamento",
    photoDeleted: "Foto eliminata",
    deleteError: "Errore nell'eliminazione",
    captionUpdated: "Descrizione aggiornata",
    today: "Oggi",
    yesterday: "Ieri",

    // === USER PROFILE ===
    profileNotFound: "Profilo non trovato",
    error: "Errore",
    reportedByUser: "Segnalato dall'utente",
    reportSent: "Segnalazione inviata",
    connectionRemovedMsg: "Collegamento rimosso",
    removeConnectionError: "Errore nella rimozione",
    connectToLike: "Collegati per mettere AdE Like",
    likeError: "Errore nel like",
    commentError: "Errore nel commento",
    requestConnection: "Richiedi Collegamento",
    pendingConnection: "In attesa...",
    alreadyConnected: "Collegato",
    sendMessage: "Invia Messaggio",
    report: "Segnala",
    block: "Blocca",
    unblock: "Sblocca",
    removeConnectionBtn: "Rimuovi collegamento",
    privateProfile: "Profilo privato",
    privateProfileMsg: "Collegati per vedere i contenuti",

    // === CHAT ===
    typeMessage: "Scrivi un messaggio...",
    chatError: "Errore nel caricamento",
    sendError2: "Errore nell'invio",
    online: "Online",
    offline: "Offline",

    // === ALERTS / NOTIFICATIONS ===
    notifications: "Notifiche",
    allNotifications: "Tutte le notifiche",
    smart: "Smart",
    markAllRead: "Segna lette",
    noNotifications: "Nessuna notifica",
    noNotificationsMsg: "Le notifiche appariranno qui",
    notificationDeleted: "Notifica eliminata",
    notifDeleteError: "Errore nell'eliminazione",
    notifUpdateError: "Errore nell'aggiornamento",
    refresh: "Aggiorna",

    // === SETTINGS ===
    settings: "Impostazioni",
    account: "ACCOUNT",
    profile: "Profilo",
    username: "Username",
    notSet: "Non impostato",
    privacy: "PRIVACY",
    visibility: "Visibilità",
    notificationsMenu: "NOTIFICHE",
    pushPreferences: "Push e preferenze",
    wallet: "PORTAFOGLIO",
    adeCoins: "Crediti ADE",
    status: "STATUS",
    goldenRing: "Golden Ring",
    securitySection: "SICUREZZA",
    accountAccess: "Account e accesso",
    preferences: "PREFERENZE",
    language: "Lingua",
    logout: "Esci dall'account",
    italian: "Italiano",
    english: "English",
    levelTxt: "Livello",

    // === ADE COINS ===
    yourBalance: "Il tuo saldo",
    buyCoins: "Acquista Crediti",
    sent: "Inviati",
    received: "Ricevuti",
    rewardPoints: "Reward Points",
    approved: "Approvato",
    pending: "In attesa",
    notEnrolled: "Non iscritto",
    payoutProgress: "Progresso payout",
    requestUnderReview: "Richiesta in fase di revisione",
    requestPayout: "Richiedi Payout",
    accumulatePoints: "Accumula {points} punti per il payout",
    becomeCreator: "Diventa Creator per guadagnare",

    // === GOLDEN RING ===
    noRing: "Nessun Ring",
    receiveGiftsToLevel: "Ricevi regali per salire di livello",
    nextLevel: "Prossimo livello",
    giftsReceived: "regali ricevuti",
    allLevels: "Tutti i livelli",
    active: "ATTIVO",
    next: "Prossimo",
    level: "Livello",
    bronzeRing: "Bronze Ring",
    silverRing: "Silver Ring",
    goldRing: "Gold Ring",
    platinumRing: "Platinum Ring",
    diamondRing: "Diamond Ring",

    // === ISLAND ===
    yourIsland: "La tua isola",
    searchIsland: "Cerca un'isola",
    search: "Cerca",
    visit: "Visita",
    noIslandFound: "Nessuna isola trovata con questo nome",
    arrivedAt: "Sei arrivato su",
    inhabitant: "Abitante",
    unknownInhabitant: "???",
    connectToDiscover: "Collegati per scoprire chi abita qui",
    ringDoorbell: "Richiedi collegamento",
    doorbellRung: "Campanello suonato!",
    connectionEstablished: "Collegamento stabilito!",
    wantsToMeetYou: "Vuole conoscerti!",
    waitingForReply: "In attesa di risposta...",
    goToRequests: "Vai nelle richieste per accettare",
    youAreConnected: "Siete collegati!",
    viewProfile: "Vedi Profilo",
    inhabitantWillBeNotified: "L'abitante riceverà una notifica",
    oceanADE: "Oceano ADE",
    takeoff: "Decollo...",
    flying: "In viaggio...",
    spotted: "Avvistata!",
    landing: "Atterraggio!",

    // === COMMON ===
    save: "Salva",
    cancel: "Annulla",
    close: "Chiudi",
    loading: "Caricamento...",
    back: "Indietro",
    confirm: "Conferma",
    delete: "Elimina",
    edit: "Modifica",
    done: "Fatto",
    retry: "Riprova",
    yes: "Sì",
    no: "No",
    ok: "OK",
    loginInProgress: "Accesso in corso...",
    deleteAccount: "Elimina Account",
    security: "Sicurezza",
  },

  en: {
    // ADE Missions
    missionLabel: "ADE MISSION", missionSponsored: "SPONSORED", missionScheduled: "SCHEDULED",
    missionStep1: "Go to the store", missionStep2: "Stay at least", missionStep3: "Get your reward",
    missionDiscover: "DISCOVER", missionInterested: "I'M INTERESTED", missionWillNotify: "WE'LL NOTIFY YOU",
    missionRemoveInterest: "Remove interest", missionAccept: "ACCEPT MISSION",
    missionDwellLabel: "Stay", missionFromYou: "from you", missionReward: "Reward",
    missionFull: "Mission sold out", missionSlotsLeft: "rewards available", missionLimited: "Limited availability",
    missionVisitStore: "Visit the store", missionStayAtLeast: "Stay at least",
    missionNotStarted: "The Mission hasn't started yet", missionGoToStore: "Reach the store",
    missionVerifiedDwell: "Verified dwell", missionVerifyInterrupted: "Location verification interrupted",
    missionVerifyResuming: "Resuming automatically…", missionStayInStore: "Stay in the store for at least",
    missionMinutes: "minutes", missionCompleted: "Mission completed!", missionInReview: "Visit under review",
    missionInReviewDesc: "Your visit is being verified. You'll get a notification once it's done.",
    missionRewarded: "You received", missionCancel: "Abandon Mission", missionCancelled: "Mission abandoned",
    missionHistory: "My Missions", missionActive: "Active Mission", missionNoHistory: "No completed Missions",
    missionOutside: "You're outside the store area", missionInside: "You're at the store",
    missionActivateTitle: "Activate ADE Missions", missionActivateDesc: "Complete your profile and accept the consents to join Missions.",
    missionFirstName: "First name", missionLastName: "Last name", missionDob: "Date of birth",
    missionResidenceCity: "City of residence", missionLocationConsent: "I consent to location verification during active Missions (app open only)",
    missionPersonalizationConsent: "I consent to personalized Mission suggestions (optional)",
    missionTermsConsent: "I accept the ADE Missions terms",
    missionActivateCta: "Activate Missions", missionActivated: "ADE Missions activated!",
    missionGpsNeeded: "Enable GPS to verify your visit", missionExpired: "Mission expired",
    missionErrorGeneric: "Error, try again", missionStatusScheduledAt: "Starts",
    missionDiscoverCta: "Discover the Mission", missionArrived: "You've arrived!",
    missionStayToComplete: "Stay in the store to complete the Mission",
    missionPresenceVerified: "Presence verified", missionReach: "REACH THE STORE",
    missionVerifying: "We're verifying your visit…", missionVerifiedDwellRow: "Verified dwell",
    missionRewardIncoming: "Reward incoming", missionVerifiedBang: "Mission verified!",
    missionGoWallet: "Go to Wallet", missionActiveHeader: "ACTIVE MISSION",
    missionStepAccepted: "Accepted", missionStepTraveling: "On the way",
    missionStepInStore: "In store", missionStepVerified: "Verified",
    missionCoinsName: "ADE Coins",
    deleteMessageTitle: "Delete message", deleteForMe: "Delete for me", deleteForEveryone: "Delete for everyone",
    deletedTombstone: "Message deleted", deleteConversation: "Delete conversation",
    deleteConversationDesc: "The conversation will be deleted only for you. The other person will still see their history.",
    conversationDeleted: "Conversation deleted", cancelAction: "Cancel",
    regCreated: "Account created! Verify your email.", regFillRequired: "Fill in all required fields",
    regAcceptConsents: "You must accept all required consents",
    regMinAge: "You must be at least 16 to use ADE", regError: "Registration error",
    giftEarnings: "Gift earnings",
    phName: "Your name *", phEmail: "Email *", phPassword: "Password *", phUsername: "Username (optional)",
    dobLabel: "Date of birth *",
    earningsPendingTitle: "Pending earnings",
    earningsPendingDesc: "Pending earnings – complete Creator activation to make them available",
    activateEarnings: "Activate earnings",
    earningsAvailableTitle: "Available earnings",
    earningsPaidTitle: "Paid",
    creatorPendingReview: "Creator application under review",
    creatorPendingReviewDesc: "Your application is being verified. Earnings stay pending until approval.",
    creatorRejectedTitle: "Creator application rejected",
    creatorRetry: "Submit a new application",
    earningsHoldInfo: "Rewards become available 14 days after they are generated",
    earningsNotSpendable: "Not spendable, transferable or withdrawable until you activate your Creator profile",
    earningsSeparateNote: "Creator Earnings (EUR) are separate from ADE Coins",
    earningsLoadError: "Could not load earnings",
    retryBtn: "Retry",
    hubExploreDesc: "Discover people and places around you",
    hubMessagesDesc: "Chat with your connections",
    hubCreditsDesc: "Manage your balance and activity",
    hubGiftsDesc: "Send and receive exclusive gifts",
    hubGoldenRingDesc: "Access exclusive privileges and perks",
    hubCreatorDesc: "Tools for creators and professionals",
    hubSettingsDesc: "Customize your ADE experience",
    storyReplyYou: "You replied to their mood",
    storyReplyToYours: "Replied to your mood",
    forgotPasswordLink: "Forgot password?",
    forgotPasswordTitle: "Recover password",
    forgotPasswordDesc: "We'll email you a temporary password. After logging in you'll set a new one.",
    tempPwdSent: "If the email is registered, you'll receive a temporary password",
    changePasswordTitle: "Change password",
    changePasswordSubtitle: "Update your account password",
    currentPwd: "Current password",
    tempPwdLabel: "Temporary password",
    newPwd: "New password",
    confirmPwd: "Confirm new password",
    confirmPasswordPh: "Confirm password",
    pwdMismatch: "Passwords do not match",
    pwdChanged: "Password updated!",
    forcedChangeNote: "You logged in with a temporary password: set a new one now.",
    callHistoryTitle: "Calls",
    callMissed: "Missed",
    callIncoming: "Incoming",
    callOutgoing: "Outgoing",
    callNoAnswer: "No answer",
    noCallsYet: "No calls yet",
    newCall: "New call",
    audioCall: "Audio",
    cropOriginal: "Original",
    cropVertical: "Vertical",
    cropHorizontal: "Horizontal",
    // === NAV ===
    navNow: "Now",
    navHere: "Here",
    navAlerts: "Alerts",
    navMe: "Me",
    navMessages: "Messages",

    // === MESSAGES ===
    messagesTitle: "Messages",
    e2eProtected: "Protected by end-to-end encryption",
    noConversations: "No conversations",
    noConversationsHint: "Connect with someone and start chatting",
    encryptedMessage: "Encrypted message",
    justNow: "now",
    chatPlaceholder: "Write a message…",
    chatEmptyState: "No messages yet. Start the conversation!",
    notDecryptable: "Not decryptable on this device",
    e2eRestoreTitle: "Restore encrypted messages",
    e2eRestoreHint: "New device? Enter your password to restore your encryption key and read your messages.",
    e2eRestoreBtn: "Restore",
    e2eRestoreWrongPass: "Wrong password or invalid backup",
    e2eRestored: "Encryption restored!",
    messageDeleted: "Message deleted",
    messageDeleteError: "Error deleting message",
    statusRead: "Read",
    statusDelivered: "Delivered",
    e2eActive: "End-to-end encryption",
    e2eUnavailable: "Encryption unavailable",
    youPrefix: "You: ",
    saveError: "Error while saving",

    // === CALLS ===
    callStarting: "Starting call…",
    callRinging: "Ringing…",
    callConnecting: "Connecting…",
    callEndedLabel: "Call ended",
    callMicError: "Microphone unavailable",
    callFailed: "Unable to start the call",
    callMicHint: "Allow microphone access: on iPhone go to Settings → AdE → Microphone",
    callE2E: "End-to-end encrypted call",
    callIncomingLabel: "Incoming audio call…",
    callAccept: "Accept",
    callDecline: "Decline",
    callOutgoingLog: "Outgoing call",
    callIncomingLog: "Incoming call",
    callMissedLog: "Missed call",
    callDeclinedLog: "Call declined",

    // === GIFT PICKER ===
    giftPickerTitle: "Send a Gift",
    giftSendBtn: "Send Gift",
    giftSending: "Sending...",

    // === PRIVACY SETTINGS ===
    readReceiptsLabel: "Read receipts",
    readReceiptsDesc: "If disabled, others won't see when you've read their messages",
    hideIdentityLabel: "Hide identity in island connections",
    hideIdentityDesc: "Even after connecting, others will only see your Island Name: real name, photo and details stay hidden",

    // === MISC PAGES ===
    imgUnavailable: "Image unavailable",
    noConnectionsShort: "No connections",
    connectToShare: "Connect with someone to share",
    newPost: "New post",
    noDescription: "No description",
    publicProfile: "Public profile",
    privateProfile: "Private profile",
    theirIsland: "Their island",
    noPostsYet: "No posts yet",
    noGiftsReceived: "No gifts received",
    reportUser: "Report user",
    reportReason: "Select the reason for the report",
    aloneOnIsland: "You're alone on the island",
    enableGpsHint: "Enable GPS to find people in the real world!",
    castaway: "Castaway on ADE Island",
    adeWorld: "ADE World",
    loadingMap: "Loading map...",
    wantsToConnect: "Wants to connect",
    newConnections: "New connections",
    noConnectionYet: "No connections",
    requestsAppearHere: "Requests and connections will appear here",
    noTagFound: "No AdETag found",
    noTagYet: "No AdETags yet",
    adeCredits: "ADE Credits",
    availableBalance: "Available balance",
    noTransactions: "No transactions",
    transactionsAppearHere: "Your transactions will appear here",
    noGiftsReceivedYet: "You haven't received any Gifts yet",
    giftsReceivedLabel: "Gifts received",
    noGiftsSentYet: "You haven't sent any Gifts yet",
    sendFirstGift: "Send your first gift!",
    showGiftsOnProfile: "Show Gifts on profile",
    othersSeeGifts: "Others can see the Gifts you've received",
    pendingResponse: "Waiting for a response...",
    noPendingRequests: "No pending requests",
    noRecentHistory: "No recent history",
    resolvedConnectionsHint: "Resolved connections appear here for 24h",
    giftCenterSub: "The gifts you've sent and received on ADE",
    giftsReceivedAppearHere: "Received gifts will appear here",
    tabReceived: "Received",
    tabSent: "Sent",

    // === CREATOR / ADE+ ===
    taxData: "Tax Details",
    personalData: "Personal Details",
    requestPayout: "Request Payout",
    noPayoutsYet: "No payouts yet",
    becomeCreator: "Become an ADE Creator",
    pointsToRedeem: "Points to redeem",
    requestPending: "Request pending",
    requestRejected: "Request rejected",
    cannotRequestPayout: "You can't request a payout",
    naturalPerson: "Natural person",
    soleProprietor: "Sole proprietor",
    confirmData: "Confirm Details",
    creatorProfile: "Creator Profile",
    availableEarnings: "Available earnings",
    pendingLabel: "Pending",
    txAppearOnGifts: "Transactions will appear when you receive Gifts",
    noCreatorTx: "No Creator transactions yet",
    manageCreatorEarnings: "Manage your Creator Rewards",
    totalRewards: "Total Rewards",
    accessUnavailable: "Access unavailable",
    cookieText: "ADE only uses technical cookies required for the app to work. We do not use profiling cookies.",
    cookieAccept: "Accept",
    cookieNecessary: "Necessary only",
    step1of2: "Step 1 of 2",
    createAccountCaps: "CREATE ACCOUNT",
    continueWithGoogle: "Continue with Google",
    continueWithApple: "Continue with Apple",
    orLabel: "or",
    usernameHint: "3-20 characters, letters, numbers, underscore",
    pwdMinHint: "Minimum 6 characters",
    minAgeHint: "You must be at least 16 (GDPR Art. 8)",
    alreadyAccount: "Already have an account?",

    // === ADE HUB ===
    hubTitle: "ADE Menu",
    hubSubtitle: "All ADE features",
    hubExplore: "Explore",
    hubMessages: "Messages",
    hubCredits: "Credits",
    hubGifts: "Gifts",
    hubGoldenRing: "Golden Ring",
    participate: "Join",
    seeAll: "See all",
    replySingular: "reply",
    participantSingular: "participant",
    discTitlePh: "Title",
    discOpeningPh: "Opening message",
    publishDiscussion: "PUBLISH DISCUSSION",
    discussionShared: "Discussion shared!",
    postShared: "Post shared!",
    commentsTxt: "comments",
    publishAction: "Post",
    shareAction: "Share",
    saveAction: "Save",
    linkCopied: "Link copied",
    timeNow: "now",
    timeDayUnit: "d",
    pinnedInHere: "Discussion followed: pinned on top of your HERE",
    doneTxt: "Done",
    reportSent: "Report sent",
    participants: "participants",
    repliesTxt: "replies",
    newInterventions: "new messages",
    discussionClosed: "Discussion closed",
    participateComposer: "Join the Discussion…",
    followTxt: "Follow",
    muteTxt: "Mute",
    unmuteTxt: "Unmute notifications",
    abandonTxt: "Leave",
    reportTxt: "Report",
    closeDiscussion: "Close Discussion",
    deleteDiscussion: "Delete Discussion",
    newDiscussion: "New Discussion",
    hubCreator: "Creator",
    hubSettings: "Settings",

    // === LANDING ===
    hereNow: "Here, Now.",
    enter: "Enter",
    createAccount: "Create account",

    // === LOGIN ===
    welcomeBack: "Welcome back",
    loginSubtitle: "Sign in to continue",
    continueWithGoogle: "Continue with Google",
    continueWithApple: "Continue with Apple",
    or: "or",
    email: "Email",
    password: "Password",
    loginWithEmail: "Sign in with Email",
    noAccount: "Don't have an account?",
    register: "Sign Up",

    // === REGISTER ===
    createAccountTitle: "CREATE ACCOUNT",
    yourName: "Your name *",
    usernameOptional: "Username (optional)",
    usernameHint: "3-20 characters, letters, numbers, underscore",
    selectCountry: "Select Country",
    passwordHint: "Minimum 6 characters",
    continue: "Continue",
    haveAccount: "Already have an account?",
    login: "Sign In",
    step1of2: "Step 1 of 2",
    step2of2: "Step 2 of 2",
    privacyConsents: "Privacy & Consents",
    privacyConsentsDesc: "To use ADE you must accept the following consents",
    termsAndConditions: "Terms & Conditions *",
    termsAcceptText: "I accept the terms of use of the ADE service",
    readTerms: "Read Terms & Conditions",
    privacyPolicy: "Privacy Policy *",
    privacyAcceptText: "I consent to the processing of my personal data according to GDPR",
    readPrivacy: "Read Privacy Policy",
    geolocation: "Geolocation *",
    geoAcceptText: "I consent to the collection and use of my GPS location",
    moreInfo: "More info",
    marketingComms: "Marketing Communications",
    optional: "optional",
    marketingAcceptText: "I want to receive news, offers and updates about ADE",
    requiredConsent: "* Required consent to use ADE",
    creating: "Creating...",
    acceptTerms: "I Accept the Terms",
    acceptPrivacy: "I Accept the Privacy Policy",
    acceptGeo: "I Consent to Geolocation",
    getStarted: "Get Started",
    alreadyHaveAccount: "Already have an account?",
    signIn: "Sign In",
    verified: "Verified",
    realTime: "Real-time",
    connectWithPeople: "Connect with interesting people\naround you in real time.",
    fillAllFields: "Please fill in all required fields",
    passwordMinLength: "Password must be at least 6 characters",
    usernameFormatError: "Username: 3-20 characters, letters, numbers, underscore only",
    mustAcceptConsents: "You must accept all required consents",
    accountCreated: "Account created! Verify your email.",
    registrationError: "Registration error",

    // === VERIFY EMAIL ===
    verifyYourEmail: "Verify your email",
    enterOtp: "Enter the 6-digit code sent to",
    enterOtpGeneric: "Enter the 6-digit code to verify your email",
    testMode: "Test mode",
    testModeDesc: "In production the code will arrive via email. For now use:",
    verifyEmail: "Verify Email",
    verifying: "Verifying...",
    enterFullCode: "Enter the full 6-digit code",
    invalidCode: "Invalid code",
    emailVerified: "Email verified!",
    redirecting: "Redirecting...",
    resendIn: "Resend in",
    didntReceiveCode: "Didn't receive the code? Resend",
    newCodeSent: "New code sent!",
    testCode: "Test code:",
    sendError: "Error sending",

    // === HOME / FEED ===
    mood: "Mood",
    startSharing: "Start sharing",
    publishFirstPhoto: "Publish your first photo or connect with someone",
    publishPhoto: "Publish photo",
    feedError: "Error loading feed",
    saveError: "Error saving",
    shareError: "Error sharing",
    now: "now",
    minutesAgo: "min ago",
    hoursAgo: "h ago",
    daysAgo: "d ago",
    share: "Share",
    saveTxt: "Save",
    comments: "comments",
    writeComment: "Write a comment...",
    send: "Send",
    cropPhoto: "Crop photo",
    publishing: "Publishing...",
    publish: "Publish",
    updateError: "Error updating",
    addCaption: "Add a caption...",
    deletePhoto: "Delete photo",
    editCaption: "Edit caption",
    adeLike: "AdE Like",

    // === HERE PAGE ===
    here: "Here",
    discoverNearby: "DISCOVER WHO'S NEARBY",
    gpsNotActive: "GPS not active",
    gpsActivateMsg: "Enable GPS to find people near you",
    activateGps: "Enable GPS",
    peopleNearby: "people nearby",
    personNearby: "person nearby",
    noOneNearby: "No one nearby",
    noOneNearbyMsg: "Enable GPS and get close to other people to discover them",
    connect: "Connect",
    cancelRequest: "Cancel",
    accept: "Accept",
    decline: "Decline",
    requestSent: "Request sent",
    connectionEstablishedMsg: "Connection established!",
    message: "Message",
    onAdeIsland: "On ADE Island",
    adeIslandWelcome: "Welcome to ADE Island!",
    adeIslandMsg: "GPS is not active, you've been placed on ADE Island where you can meet other users.",
    requestSentToast: "Request sent!",
    requestCancelled: "Request cancelled",
    requestAccepted: "Request accepted!",
    requestDeclined: "Request declined",
    requestError: "Request error",
    cancelError: "Error cancelling",

    // === HERE - ISLAND TAB ===
    myIsland: "My island",
    islandShareMsg: "Share your island name so people can find you on ADE Island!",
    copy: "Copy",
    copiedToClipboard: "Copied!",
    worldMap: "World Map",
    searchIslandPlaceholder: "Search an island...",

    // === HERE - REQUESTS TAB ===
    pendingRequests: "Incoming requests",
    sentRequestsTitle: "Sent requests",
    recentHistory: "Recent history",
    noPendingRequests: "No incoming requests",
    noSentRequests: "No sent requests",
    noRecentHistory: "No recent activity",
    accepted: "Accepted",
    declined: "Declined",

    // === HERE - CONNECTED TAB ===
    yourConnections: "Your connections",
    noConnections: "No connections yet",
    noConnectionsMsg: "Connect with the people you meet!",
    removeConnection: "Remove connection",
    connectionRemoved: "Connection removed",
    removeError: "Error removing",

    // === PROFILE ===
    post: "Post",
    posts: "Posts",
    connectionsTxt: "Connections",
    adeLikes: "AdE Likes",
    editProfile: "Edit profile",
    addPhotoBtn: "+ Add",
    noPostsYet: "No posts yet",
    publishFirstPhotoLink: "Publish your first photo",
    profileError: "Error loading profile",
    profilePicUpdated: "Profile picture updated",
    coverUpdated: "Cover updated",
    uploadError: "Upload error",
    photoDeleted: "Photo deleted",
    deleteError: "Error deleting",
    captionUpdated: "Caption updated",
    today: "Today",
    yesterday: "Yesterday",

    // === USER PROFILE ===
    profileNotFound: "Profile not found",
    error: "Error",
    reportedByUser: "Reported by user",
    reportSent: "Report sent",
    connectionRemovedMsg: "Connection removed",
    removeConnectionError: "Error removing connection",
    connectToLike: "Connect to give AdE Like",
    likeError: "Error liking",
    commentError: "Error commenting",
    requestConnection: "Request Connection",
    pendingConnection: "Pending...",
    alreadyConnected: "Connected",
    sendMessage: "Send Message",
    report: "Report",
    block: "Block",
    unblock: "Unblock",
    removeConnectionBtn: "Remove connection",
    privateProfile: "Private profile",
    privateProfileMsg: "Connect to see content",

    // === CHAT ===
    typeMessage: "Type a message...",
    chatError: "Error loading chat",
    sendError2: "Error sending",
    online: "Online",
    offline: "Offline",

    // === ALERTS / NOTIFICATIONS ===
    notifications: "Notifications",
    allNotifications: "All notifications",
    smart: "Smart",
    markAllRead: "Mark read",
    noNotifications: "No notifications",
    noNotificationsMsg: "Notifications will appear here",
    notificationDeleted: "Notification deleted",
    notifDeleteError: "Error deleting",
    notifUpdateError: "Error updating",
    refresh: "Refresh",

    // === SETTINGS ===
    settings: "Settings",
    account: "ACCOUNT",
    profile: "Profile",
    username: "Username",
    notSet: "Not set",
    privacy: "PRIVACY",
    visibility: "Visibility",
    notificationsMenu: "NOTIFICATIONS",
    pushPreferences: "Push & preferences",
    wallet: "WALLET",
    adeCoins: "Crediti ADE",
    status: "STATUS",
    goldenRing: "Golden Ring",
    securitySection: "SECURITY",
    accountAccess: "Account & access",
    preferences: "PREFERENCES",
    language: "Language",
    logout: "Log out",
    italian: "Italiano",
    english: "English",
    levelTxt: "Level",

    // === ADE COINS ===
    yourBalance: "Your balance",
    buyCoins: "Buy Credits",
    sent: "Sent",
    received: "Received",
    rewardPoints: "Reward Points",
    approved: "Approved",
    pending: "Pending",
    notEnrolled: "Not enrolled",
    payoutProgress: "Payout progress",
    requestUnderReview: "Request under review",
    requestPayout: "Request Payout",
    accumulatePoints: "Accumulate {points} points for payout",
    becomeCreator: "Become a Creator to earn",

    // === GOLDEN RING ===
    noRing: "No Ring",
    receiveGiftsToLevel: "Receive gifts to level up",
    nextLevel: "Next level",
    giftsReceived: "gifts received",
    allLevels: "All levels",
    active: "ACTIVE",
    next: "Next",
    level: "Level",
    bronzeRing: "Bronze Ring",
    silverRing: "Silver Ring",
    goldRing: "Gold Ring",
    platinumRing: "Platinum Ring",
    diamondRing: "Diamond Ring",

    // === ISLAND ===
    yourIsland: "Your island",
    searchIsland: "Search an island",
    search: "Search",
    visit: "Visit",
    noIslandFound: "No island found with this name",
    arrivedAt: "You arrived at",
    inhabitant: "Inhabitant",
    unknownInhabitant: "???",
    connectToDiscover: "Connect to discover who lives here",
    ringDoorbell: "Request connection",
    doorbellRung: "Doorbell rung!",
    connectionEstablished: "Connection established!",
    wantsToMeetYou: "Wants to meet you!",
    waitingForReply: "Waiting for reply...",
    goToRequests: "Go to requests to accept",
    youAreConnected: "You're connected!",
    viewProfile: "View Profile",
    inhabitantWillBeNotified: "The inhabitant will be notified",
    oceanADE: "ADE Ocean",
    takeoff: "Takeoff...",
    flying: "Flying...",
    spotted: "Spotted!",
    landing: "Landing!",

    // === COMMON ===
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    loading: "Loading...",
    back: "Back",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    done: "Done",
    retry: "Retry",
    yes: "Yes",
    no: "No",
    ok: "OK",
    loginInProgress: "Signing in...",
    deleteAccount: "Delete Account",
    security: "Security",
  },
  es: {
    deleteMessageTitle: "Eliminar mensaje", deleteForMe: "Eliminar para mí", deleteForEveryone: "Eliminar para todos",
    deletedTombstone: "Mensaje eliminado", deleteConversation: "Eliminar conversación",
    deleteConversationDesc: "La conversación se eliminará solo para ti. La otra persona seguirá viendo su historial.",
    conversationDeleted: "Conversación eliminada", cancelAction: "Cancelar",
    giftEarnings: "Ganancias por regalos",
    earningsPendingTitle: "Ganancias pendientes",
    earningsPendingDesc: "Ganancias pendientes – completa la activación Creator para que estén disponibles",
    activateEarnings: "Activar ganancias",
    earningsAvailableTitle: "Ganancias disponibles",
    earningsPaidTitle: "Pagado",
    creatorPendingReview: "Solicitud Creator en revisión",
    creatorPendingReviewDesc: "Tu solicitud está siendo verificada. Las ganancias permanecen pendientes hasta la aprobación.",
    creatorRejectedTitle: "Solicitud Creator rechazada",
    creatorRetry: "Enviar nueva solicitud",
    earningsHoldInfo: "Los Rewards estarán disponibles 14 días después de su generación",
    earningsNotSpendable: "No se puede gastar, transferir ni retirar hasta que actives tu perfil Creator",
    earningsSeparateNote: "Las Ganancias Creator (EUR) están separadas de los ADE Coins",
    earningsLoadError: "No se pudieron cargar las ganancias",
    retryBtn: "Reintentar",
    hubExploreDesc: "Descubre personas y lugares cerca de ti",
    hubMessagesDesc: "Chatea con tus conexiones",
    hubCreditsDesc: "Gestiona tu saldo y movimientos",
    hubGiftsDesc: "Envía y recibe regalos exclusivos",
    hubGoldenRingDesc: "Accede a privilegios y ventajas exclusivas",
    hubCreatorDesc: "Herramientas para creators y profesionales",
    hubSettingsDesc: "Personaliza tu experiencia ADE",
    storyReplyYou: "Respondiste a su mood",
    storyReplyToYours: "Respondió a tu mood",
    forgotPasswordLink: "¿Olvidaste la contraseña?",
    forgotPasswordTitle: "Recuperar contraseña",
    forgotPasswordDesc: "Te enviaremos una contraseña provisional por email. Después deberás establecer una nueva.",
    tempPwdSent: "Si el email está registrado, recibirás una contraseña provisional",
    changePasswordTitle: "Cambiar contraseña",
    changePasswordSubtitle: "Actualiza la contraseña de tu cuenta",
    currentPwd: "Contraseña actual",
    tempPwdLabel: "Contraseña provisional",
    newPwd: "Nueva contraseña",
    confirmPwd: "Confirma la nueva contraseña",
    confirmPasswordPh: "Confirmar contraseña",
    pwdMismatch: "Las contraseñas no coinciden",
    pwdChanged: "¡Contraseña actualizada!",
    forcedChangeNote: "Has iniciado sesión con una contraseña provisional: establece una nueva ahora.",
    callHistoryTitle: "Llamadas",
    callMissed: "Perdida",
    callIncoming: "Recibida",
    callOutgoing: "Realizada",
    callNoAnswer: "Sin respuesta",
    noCallsYet: "Aún no hay llamadas",
    newCall: "Nueva llamada",
    audioCall: "Audio",
    cropOriginal: "Original",
    cropVertical: "Vertical",
    cropHorizontal: "Horizontal",
    navNow: "Now", navHere: "Here", navAlerts: "Alertas", navMe: "Yo", navMessages: "Mensajes",
    hereNow: "Here, Now.", enter: "Entrar",
    messagesTitle: "Mensajes", e2eProtected: "Protegidas con cifrado de extremo a extremo",
    noConversations: "Sin conversaciones", noConversationsHint: "Conecta con alguien y empieza a chatear",
    encryptedMessage: "Mensaje cifrado", justNow: "ahora",
    chatPlaceholder: "Escribe un mensaje…", chatEmptyState: "Aún no hay mensajes. ¡Empieza la conversación!",
    notDecryptable: "No descifrable en este dispositivo",
    e2eActive: "Cifrado de extremo a extremo", e2eUnavailable: "Cifrado no disponible",
    youPrefix: "Tú: ", saveError: "Error al guardar",
    e2eRestoreTitle: "Restaurar mensajes cifrados",
    e2eRestoreHint: "¿Nuevo dispositivo? Introduce tu contraseña para restaurar la clave de cifrado.",
    e2eRestoreBtn: "Restaurar", e2eRestoreWrongPass: "Contraseña incorrecta o copia no válida", e2eRestored: "¡Cifrado restaurado!",
    messageDeleted: "Mensaje eliminado", messageDeleteError: "Error al eliminar",
    statusRead: "Leído", statusDelivered: "Entregado",
    callStarting: "Iniciando llamada…", callRinging: "Sonando…", callConnecting: "Conectando…",
    callEndedLabel: "Llamada finalizada", callMicError: "Micrófono no disponible", callFailed: "No se pudo iniciar la llamada", callMicHint: "Permite el acceso al micrófono: en iPhone ve a Ajustes → AdE → Micrófono",
    callE2E: "Llamada cifrada de extremo a extremo", callIncomingLabel: "Llamada de audio entrante…",
    callAccept: "Aceptar", callDecline: "Rechazar",
    callOutgoingLog: "Llamada realizada", callIncomingLog: "Llamada recibida",
    callMissedLog: "Llamada perdida", callDeclinedLog: "Llamada rechazada",
    giftPickerTitle: "Enviar un Gift", giftSendBtn: "Enviar Gift", giftSending: "Enviando...",
    readReceiptsLabel: "Confirmaciones de lectura",
    readReceiptsDesc: "Si está desactivado, los demás no verán cuándo has leído sus mensajes",
    hideIdentityLabel: "Ocultar identidad en las conexiones de isla",
    hideIdentityDesc: "Incluso después de conectar, los demás solo verán tu Nombre de Isla",
    hubTitle: "Menú ADE", hubSubtitle: "Todas las funciones de ADE",
    hubExplore: "Explorar", hubMessages: "Mensajes", hubCredits: "Créditos", hubGifts: "Gifts",
    hubGoldenRing: "Golden Ring", hubCreator: "Creator", hubSettings: "Ajustes",
    imgUnavailable: "Imagen no disponible", noConnectionsShort: "Sin conexiones",
    connectToShare: "Conecta con alguien para compartir", newPost: "Nueva publicación", noDescription: "Sin descripción",
    publicProfile: "Perfil público", privateProfile: "Perfil privado", theirIsland: "Su isla",
    noPostsYet: "Aún no hay publicaciones", noGiftsReceived: "Ningún regalo recibido",
    reportUser: "Denunciar usuario", reportReason: "Selecciona el motivo de la denuncia",
    aloneOnIsland: "Estás solo en la isla", enableGpsHint: "¡Activa el GPS para encontrar gente en el mundo real!",
    castaway: "Náufrago en ADE Island", adeWorld: "Mundo ADE", loadingMap: "Cargando mapa...",
    wantsToConnect: "Quiere conectar", newConnections: "Nuevas conexiones", noConnectionYet: "Sin conexiones",
    requestsAppearHere: "Las solicitudes y conexiones aparecerán aquí",
    noTagFound: "Ningún AdETag encontrado", noTagYet: "Aún no hay AdETags",
    adeCredits: "Créditos ADE", availableBalance: "Saldo disponible",
    noTransactions: "Sin transacciones", transactionsAppearHere: "Tus operaciones aparecerán aquí",
    noGiftsReceivedYet: "Aún no has recibido Gifts", giftsReceivedLabel: "Gifts recibidos",
    noGiftsSentYet: "Aún no has enviado Gifts", sendFirstGift: "¡Envía tu primer regalo!",
    showGiftsOnProfile: "Mostrar Gifts en el perfil", othersSeeGifts: "Los demás ven los Gifts que has recibido",
    pendingResponse: "Esperando respuesta...", noPendingRequests: "Sin solicitudes pendientes",
    noRecentHistory: "Sin historial reciente", resolvedConnectionsHint: "Las conexiones resueltas aparecen aquí durante 24h",
    giftCenterSub: "Los regalos que has enviado y recibido en ADE", giftsReceivedAppearHere: "Los regalos recibidos aparecerán aquí",
    tabReceived: "Recibidos", tabSent: "Enviados",
    phName: "Tu nombre *", phEmail: "Email *", phPassword: "Contraseña *", phUsername: "Usuario (opcional)",
    selectCountry: "Selecciona país", dobLabel: "Fecha de nacimiento *",
    regCreated: "¡Cuenta creada! Verifica tu email.", regFillRequired: "Completa todos los campos obligatorios",
    regAcceptConsents: "Debes aceptar todos los consentimientos obligatorios",
    regMinAge: "Debes tener al menos 16 años para usar ADE", regError: "Error en el registro",
    regEnterDob: "Introduce tu fecha de nacimiento", regPwdMin: "La contraseña debe tener al menos 6 caracteres",
    regUsernameRule: "Usuario: 3-20 caracteres, solo letras, números y guion bajo",
    cookieText: "ADE solo utiliza cookies técnicas necesarias para el funcionamiento de la app. No usamos cookies de perfilado.",
    cookieAccept: "Aceptar",
    cookieNecessary: "Solo necesarias",
    step1of2: "Paso 1 de 2",
    createAccountCaps: "CREAR CUENTA",
    continueWithGoogle: "Continuar con Google",
    continueWithApple: "Continuar con Apple",
    orLabel: "o",
    usernameHint: "3-20 caracteres, letras, números, guion bajo",
    pwdMinHint: "Mínimo 6 caracteres",
    minAgeHint: "Debes tener al menos 16 años (RGPD Art. 8)",
    alreadyAccount: "¿Ya tienes una cuenta?",
  },
  fr: {
    deleteMessageTitle: "Supprimer le message", deleteForMe: "Supprimer pour moi", deleteForEveryone: "Supprimer pour tous",
    deletedTombstone: "Message supprimé", deleteConversation: "Supprimer la conversation",
    deleteConversationDesc: "La conversation sera supprimée uniquement pour vous. L'autre personne verra toujours son historique.",
    conversationDeleted: "Conversation supprimée", cancelAction: "Annuler",
    giftEarnings: "Gains des cadeaux",
    earningsPendingTitle: "Gains en attente",
    earningsPendingDesc: "Gains en attente – complète l'activation Creator pour les rendre disponibles",
    activateEarnings: "Activer les gains",
    earningsAvailableTitle: "Gains disponibles",
    earningsPaidTitle: "Payé",
    creatorPendingReview: "Demande Creator en cours de révision",
    creatorPendingReviewDesc: "Ta demande est en cours de vérification. Les gains restent en attente jusqu'à l'approbation.",
    creatorRejectedTitle: "Demande Creator refusée",
    creatorRetry: "Envoyer une nouvelle demande",
    earningsHoldInfo: "Les Rewards deviennent disponibles 14 jours après leur génération",
    earningsNotSpendable: "Non dépensable, transférable ou retirable tant que tu n'actives pas ton profil Creator",
    earningsSeparateNote: "Les Gains Creator (EUR) sont séparés des ADE Coins",
    earningsLoadError: "Impossible de charger les gains",
    retryBtn: "Réessayer",
    hubExploreDesc: "Découvre des personnes et des lieux autour de toi",
    hubMessagesDesc: "Discute avec tes connexions",
    hubCreditsDesc: "Gère ton solde et tes mouvements",
    hubGiftsDesc: "Envoie et reçois des cadeaux exclusifs",
    hubGoldenRingDesc: "Accède à des privilèges exclusifs",
    hubCreatorDesc: "Outils pour créateurs et professionnels",
    hubSettingsDesc: "Personnalise ton expérience ADE",
    storyReplyYou: "Tu as répondu à son mood",
    storyReplyToYours: "A répondu à ton mood",
    forgotPasswordLink: "Mot de passe oublié ?",
    forgotPasswordTitle: "Récupérer le mot de passe",
    forgotPasswordDesc: "Nous t'enverrons un mot de passe provisoire par email. Ensuite tu devras en définir un nouveau.",
    tempPwdSent: "Si l'email est enregistré, tu recevras un mot de passe provisoire",
    changePasswordTitle: "Changer le mot de passe",
    changePasswordSubtitle: "Mets à jour le mot de passe de ton compte",
    currentPwd: "Mot de passe actuel",
    tempPwdLabel: "Mot de passe provisoire",
    newPwd: "Nouveau mot de passe",
    confirmPwd: "Confirme le nouveau mot de passe",
    confirmPasswordPh: "Confirmer le mot de passe",
    pwdMismatch: "Les mots de passe ne correspondent pas",
    pwdChanged: "Mot de passe mis à jour !",
    forcedChangeNote: "Tu t'es connecté avec un mot de passe provisoire : définis-en un nouveau maintenant.",
    callHistoryTitle: "Appels",
    callMissed: "Manqué",
    callIncoming: "Reçu",
    callOutgoing: "Sortant",
    callNoAnswer: "Sans réponse",
    noCallsYet: "Aucun appel pour le moment",
    newCall: "Nouvel appel",
    audioCall: "Audio",
    cropOriginal: "Original",
    cropVertical: "Vertical",
    cropHorizontal: "Horizontal",
    navNow: "Now", navHere: "Here", navAlerts: "Alertes", navMe: "Moi", navMessages: "Messages",
    hereNow: "Here, Now.", enter: "Entrer",
    messagesTitle: "Messages", e2eProtected: "Protégées par chiffrement de bout en bout",
    noConversations: "Aucune conversation", noConversationsHint: "Connecte-toi avec quelqu'un et commence à discuter",
    encryptedMessage: "Message chiffré", justNow: "à l'instant",
    chatPlaceholder: "Écris un message…", chatEmptyState: "Pas encore de messages. Lance la conversation !",
    notDecryptable: "Non déchiffrable sur cet appareil",
    e2eActive: "Chiffrement de bout en bout", e2eUnavailable: "Chiffrement indisponible",
    youPrefix: "Toi : ", saveError: "Erreur d'enregistrement",
    e2eRestoreTitle: "Restaurer les messages chiffrés",
    e2eRestoreHint: "Nouvel appareil ? Saisis ton mot de passe pour restaurer la clé de chiffrement.",
    e2eRestoreBtn: "Restaurer", e2eRestoreWrongPass: "Mot de passe incorrect ou sauvegarde invalide", e2eRestored: "Chiffrement restauré !",
    messageDeleted: "Message supprimé", messageDeleteError: "Erreur de suppression",
    statusRead: "Lu", statusDelivered: "Distribué",
    callStarting: "Appel en cours…", callRinging: "Ça sonne…", callConnecting: "Connexion…",
    callEndedLabel: "Appel terminé", callMicError: "Micro indisponible", callFailed: "Impossible de démarrer l'appel", callMicHint: "Autorise l'accès au micro : sur iPhone, Réglages → AdE → Micro",
    callE2E: "Appel chiffré de bout en bout", callIncomingLabel: "Appel audio entrant…",
    callAccept: "Accepter", callDecline: "Refuser",
    callOutgoingLog: "Appel émis", callIncomingLog: "Appel reçu",
    callMissedLog: "Appel manqué", callDeclinedLog: "Appel refusé",
    giftPickerTitle: "Envoyer un Gift", giftSendBtn: "Envoyer le Gift", giftSending: "Envoi...",
    readReceiptsLabel: "Confirmations de lecture",
    readReceiptsDesc: "Si désactivé, les autres ne verront pas quand tu as lu leurs messages",
    hideIdentityLabel: "Masquer l'identité dans les connexions d'île",
    hideIdentityDesc: "Même après la connexion, les autres ne verront que ton Nom d'Île",
    hubTitle: "Menu ADE", hubSubtitle: "Toutes les fonctionnalités d'ADE",
    hubExplore: "Explorer", hubMessages: "Messages", hubCredits: "Crédits", hubGifts: "Gifts",
    hubGoldenRing: "Golden Ring", hubCreator: "Créateur", hubSettings: "Réglages",
    imgUnavailable: "Image indisponible", noConnectionsShort: "Aucune connexion",
    connectToShare: "Connecte-toi avec quelqu'un pour partager", newPost: "Nouveau post", noDescription: "Aucune description",
    publicProfile: "Profil public", privateProfile: "Profil privé", theirIsland: "Son île",
    noPostsYet: "Pas encore de posts", noGiftsReceived: "Aucun cadeau reçu",
    reportUser: "Signaler l'utilisateur", reportReason: "Sélectionne le motif du signalement",
    aloneOnIsland: "Tu es seul sur l'île", enableGpsHint: "Active le GPS pour trouver des gens dans le monde réel !",
    castaway: "Naufragé sur ADE Island", adeWorld: "Monde ADE", loadingMap: "Chargement de la carte...",
    wantsToConnect: "Veut se connecter", newConnections: "Nouvelles connexions", noConnectionYet: "Aucune connexion",
    requestsAppearHere: "Les demandes et connexions apparaîtront ici",
    noTagFound: "Aucun AdETag trouvé", noTagYet: "Pas encore d'AdETags",
    adeCredits: "Crédits ADE", availableBalance: "Solde disponible",
    noTransactions: "Aucune transaction", transactionsAppearHere: "Tes opérations apparaîtront ici",
    noGiftsReceivedYet: "Tu n'as pas encore reçu de Gifts", giftsReceivedLabel: "Gifts reçus",
    noGiftsSentYet: "Tu n'as pas encore envoyé de Gifts", sendFirstGift: "Envoie ton premier cadeau !",
    showGiftsOnProfile: "Afficher les Gifts sur le profil", othersSeeGifts: "Les autres voient les Gifts que tu as reçus",
    pendingResponse: "En attente de réponse...", noPendingRequests: "Aucune demande en attente",
    noRecentHistory: "Aucun historique récent", resolvedConnectionsHint: "Les connexions résolues apparaissent ici pendant 24h",
    giftCenterSub: "Les cadeaux que tu as envoyés et reçus sur ADE", giftsReceivedAppearHere: "Les cadeaux reçus apparaîtront ici",
    tabReceived: "Reçus", tabSent: "Envoyés",
    phName: "Ton nom *", phEmail: "Email *", phPassword: "Mot de passe *", phUsername: "Pseudo (facultatif)",
    selectCountry: "Sélectionne un pays", dobLabel: "Date de naissance *",
    regCreated: "Compte créé ! Vérifie ton email.", regFillRequired: "Remplis tous les champs obligatoires",
    regAcceptConsents: "Tu dois accepter tous les consentements obligatoires",
    regMinAge: "Tu dois avoir au moins 16 ans pour utiliser ADE", regError: "Erreur lors de l'inscription",
    regEnterDob: "Saisis ta date de naissance", regPwdMin: "Le mot de passe doit contenir au moins 6 caractères",
    regUsernameRule: "Pseudo : 3-20 caractères, lettres, chiffres et underscore uniquement",
    cookieText: "ADE utilise uniquement des cookies techniques nécessaires au fonctionnement de l'app. Aucun cookie de profilage.",
    cookieAccept: "Accepter",
    cookieNecessary: "Nécessaires uniquement",
    step1of2: "Étape 1 sur 2",
    createAccountCaps: "CRÉER UN COMPTE",
    continueWithGoogle: "Continuer avec Google",
    continueWithApple: "Continuer avec Apple",
    orLabel: "ou",
    usernameHint: "3-20 caractères, lettres, chiffres, underscore",
    pwdMinHint: "Minimum 6 caractères",
    minAgeHint: "Tu dois avoir au moins 16 ans (RGPD Art. 8)",
    alreadyAccount: "Tu as déjà un compte ?",
  },
  de: {
    deleteMessageTitle: "Nachricht löschen", deleteForMe: "Für mich löschen", deleteForEveryone: "Für alle löschen",
    deletedTombstone: "Nachricht gelöscht", deleteConversation: "Unterhaltung löschen",
    deleteConversationDesc: "Die Unterhaltung wird nur für dich gelöscht. Die andere Person sieht weiterhin ihren Verlauf.",
    conversationDeleted: "Unterhaltung gelöscht", cancelAction: "Abbrechen",
    giftEarnings: "Geschenk-Einnahmen",
    earningsPendingTitle: "Ausstehende Einnahmen",
    earningsPendingDesc: "Ausstehende Einnahmen – schließe die Creator-Aktivierung ab, um sie verfügbar zu machen",
    activateEarnings: "Einnahmen aktivieren",
    earningsAvailableTitle: "Verfügbare Einnahmen",
    earningsPaidTitle: "Ausgezahlt",
    creatorPendingReview: "Creator-Antrag in Prüfung",
    creatorPendingReviewDesc: "Dein Antrag wird geprüft. Einnahmen bleiben bis zur Genehmigung ausstehend.",
    creatorRejectedTitle: "Creator-Antrag abgelehnt",
    creatorRetry: "Neuen Antrag senden",
    earningsHoldInfo: "Rewards werden 14 Tage nach ihrer Erstellung verfügbar",
    earningsNotSpendable: "Nicht ausgebbar, übertragbar oder abhebbar, bis du dein Creator-Profil aktivierst",
    earningsSeparateNote: "Creator-Einnahmen (EUR) sind von ADE Coins getrennt",
    earningsLoadError: "Einnahmen konnten nicht geladen werden",
    retryBtn: "Erneut versuchen",
    hubExploreDesc: "Entdecke Menschen und Orte in deiner Nähe",
    hubMessagesDesc: "Chatte mit deinen Verbindungen",
    hubCreditsDesc: "Verwalte dein Guthaben und deine Bewegungen",
    hubGiftsDesc: "Sende und empfange exklusive Geschenke",
    hubGoldenRingDesc: "Zugang zu exklusiven Privilegien und Vorteilen",
    hubCreatorDesc: "Tools für Creator und Profis",
    hubSettingsDesc: "Personalisiere dein ADE-Erlebnis",
    storyReplyYou: "Du hast auf ihren Mood geantwortet",
    storyReplyToYours: "Hat auf deinen Mood geantwortet",
    forgotPasswordLink: "Passwort vergessen?",
    forgotPasswordTitle: "Passwort wiederherstellen",
    forgotPasswordDesc: "Wir senden dir ein vorläufiges Passwort per E-Mail. Danach musst du ein neues festlegen.",
    tempPwdSent: "Wenn die E-Mail registriert ist, erhältst du ein vorläufiges Passwort",
    changePasswordTitle: "Passwort ändern",
    changePasswordSubtitle: "Aktualisiere das Passwort deines Kontos",
    currentPwd: "Aktuelles Passwort",
    tempPwdLabel: "Vorläufiges Passwort",
    newPwd: "Neues Passwort",
    confirmPwd: "Neues Passwort bestätigen",
    confirmPasswordPh: "Passwort bestätigen",
    pwdMismatch: "Die Passwörter stimmen nicht überein",
    pwdChanged: "Passwort aktualisiert!",
    forcedChangeNote: "Du hast dich mit einem vorläufigen Passwort angemeldet: Lege jetzt ein neues fest.",
    callHistoryTitle: "Anrufe",
    callMissed: "Verpasst",
    callIncoming: "Eingehend",
    callOutgoing: "Ausgehend",
    callNoAnswer: "Keine Antwort",
    noCallsYet: "Noch keine Anrufe",
    newCall: "Neuer Anruf",
    audioCall: "Audio",
    cropOriginal: "Original",
    cropVertical: "Vertikal",
    cropHorizontal: "Horizontal",
    navNow: "Now", navHere: "Here", navAlerts: "Meldungen", navMe: "Ich", navMessages: "Nachrichten",
    hereNow: "Here, Now.", enter: "Eintreten",
    messagesTitle: "Nachrichten", e2eProtected: "Durch Ende-zu-Ende-Verschlüsselung geschützt",
    noConversations: "Keine Unterhaltungen", noConversationsHint: "Verbinde dich mit jemandem und beginne zu chatten",
    encryptedMessage: "Verschlüsselte Nachricht", justNow: "jetzt",
    chatPlaceholder: "Schreibe eine Nachricht…", chatEmptyState: "Noch keine Nachrichten. Starte die Unterhaltung!",
    notDecryptable: "Auf diesem Gerät nicht entschlüsselbar",
    e2eActive: "Ende-zu-Ende-Verschlüsselung", e2eUnavailable: "Verschlüsselung nicht verfügbar",
    youPrefix: "Du: ", saveError: "Fehler beim Speichern",
    e2eRestoreTitle: "Verschlüsselte Nachrichten wiederherstellen",
    e2eRestoreHint: "Neues Gerät? Gib dein Passwort ein, um den Schlüssel wiederherzustellen.",
    e2eRestoreBtn: "Wiederherstellen", e2eRestoreWrongPass: "Falsches Passwort oder ungültiges Backup", e2eRestored: "Verschlüsselung wiederhergestellt!",
    messageDeleted: "Nachricht gelöscht", messageDeleteError: "Fehler beim Löschen",
    statusRead: "Gelesen", statusDelivered: "Zugestellt",
    callStarting: "Anruf wird gestartet…", callRinging: "Es klingelt…", callConnecting: "Verbinden…",
    callEndedLabel: "Anruf beendet", callMicError: "Mikrofon nicht verfügbar", callFailed: "Anruf konnte nicht gestartet werden", callMicHint: "Erlaube den Mikrofonzugriff: Einstellungen → AdE → Mikrofon",
    callE2E: "Ende-zu-Ende-verschlüsselter Anruf", callIncomingLabel: "Eingehender Audioanruf…",
    callAccept: "Annehmen", callDecline: "Ablehnen",
    callOutgoingLog: "Ausgehender Anruf", callIncomingLog: "Eingehender Anruf",
    callMissedLog: "Verpasster Anruf", callDeclinedLog: "Anruf abgelehnt",
    giftPickerTitle: "Gift senden", giftSendBtn: "Gift senden", giftSending: "Senden...",
    readReceiptsLabel: "Lesebestätigungen",
    readReceiptsDesc: "Wenn deaktiviert, sehen andere nicht, wann du ihre Nachrichten gelesen hast",
    hideIdentityLabel: "Identität in Insel-Verbindungen verbergen",
    hideIdentityDesc: "Auch nach der Verbindung sehen andere nur deinen Inselnamen",
    hubTitle: "ADE-Menü", hubSubtitle: "Alle ADE-Funktionen",
    hubExplore: "Entdecken", hubMessages: "Nachrichten", hubCredits: "Credits", hubGifts: "Gifts",
    hubGoldenRing: "Golden Ring", hubCreator: "Creator", hubSettings: "Einstellungen",
    imgUnavailable: "Bild nicht verfügbar", noConnectionsShort: "Keine Verbindungen",
    connectToShare: "Verbinde dich mit jemandem, um zu teilen", newPost: "Neuer Beitrag", noDescription: "Keine Beschreibung",
    publicProfile: "Öffentliches Profil", privateProfile: "Privates Profil", theirIsland: "Seine/ihre Insel",
    noPostsYet: "Noch keine Beiträge", noGiftsReceived: "Keine Geschenke erhalten",
    reportUser: "Nutzer melden", reportReason: "Wähle den Grund für die Meldung",
    aloneOnIsland: "Du bist allein auf der Insel", enableGpsHint: "Aktiviere GPS, um Leute in der realen Welt zu finden!",
    castaway: "Schiffbrüchiger auf ADE Island", adeWorld: "ADE-Welt", loadingMap: "Karte wird geladen...",
    wantsToConnect: "Möchte sich verbinden", newConnections: "Neue Verbindungen", noConnectionYet: "Keine Verbindungen",
    requestsAppearHere: "Anfragen und Verbindungen erscheinen hier",
    noTagFound: "Kein AdETag gefunden", noTagYet: "Noch keine AdETags",
    adeCredits: "ADE-Credits", availableBalance: "Verfügbares Guthaben",
    noTransactions: "Keine Transaktionen", transactionsAppearHere: "Deine Vorgänge erscheinen hier",
    noGiftsReceivedYet: "Du hast noch keine Gifts erhalten", giftsReceivedLabel: "Erhaltene Gifts",
    noGiftsSentYet: "Du hast noch keine Gifts gesendet", sendFirstGift: "Sende dein erstes Geschenk!",
    showGiftsOnProfile: "Gifts im Profil anzeigen", othersSeeGifts: "Andere sehen die Gifts, die du erhalten hast",
    pendingResponse: "Warte auf Antwort...", noPendingRequests: "Keine ausstehenden Anfragen",
    noRecentHistory: "Kein aktueller Verlauf", resolvedConnectionsHint: "Abgeschlossene Verbindungen erscheinen hier für 24h",
    giftCenterSub: "Die Geschenke, die du auf ADE gesendet und erhalten hast", giftsReceivedAppearHere: "Erhaltene Geschenke erscheinen hier",
    tabReceived: "Erhalten", tabSent: "Gesendet",
    phName: "Dein Name *", phEmail: "E-Mail *", phPassword: "Passwort *", phUsername: "Benutzername (optional)",
    selectCountry: "Land auswählen", dobLabel: "Geburtsdatum *",
    regCreated: "Konto erstellt! Bestätige deine E-Mail.", regFillRequired: "Fülle alle Pflichtfelder aus",
    regAcceptConsents: "Du musst allen erforderlichen Einwilligungen zustimmen",
    regMinAge: "Du musst mindestens 16 Jahre alt sein, um ADE zu nutzen", regError: "Fehler bei der Registrierung",
    regEnterDob: "Gib dein Geburtsdatum ein", regPwdMin: "Das Passwort muss mindestens 6 Zeichen haben",
    regUsernameRule: "Benutzername: 3-20 Zeichen, nur Buchstaben, Zahlen, Unterstrich",
    cookieText: "ADE verwendet nur technisch notwendige Cookies für den Betrieb der App. Keine Profiling-Cookies.",
    cookieAccept: "Akzeptieren",
    cookieNecessary: "Nur notwendige",
    step1of2: "Schritt 1 von 2",
    createAccountCaps: "KONTO ERSTELLEN",
    continueWithGoogle: "Mit Google fortfahren",
    continueWithApple: "Mit Apple fortfahren",
    orLabel: "oder",
    usernameHint: "3-20 Zeichen, Buchstaben, Zahlen, Unterstrich",
    pwdMinHint: "Mindestens 6 Zeichen",
    minAgeHint: "Du musst mindestens 16 Jahre alt sein (DSGVO Art. 8)",
    alreadyAccount: "Hast du schon ein Konto?",
  },
};

// Get saved language, or detect device language on first launch
export function getLang() {
  const saved = localStorage.getItem("ade_language");
  if (saved) return saved;
  const supported = ["it", "en", "es", "fr", "de"];
  const device = (navigator.language || "en").slice(0, 2).toLowerCase();
  return supported.includes(device) ? device : "en";
}

export function setLang(lang) {
  localStorage.setItem("ade_language", lang);
  window.dispatchEvent(new Event("ade-lang-change"));
}

export function t(key) {
  const lang = getLang();
  return translations[lang]?.[key] || translations.en[key] || translations.it[key] || key;
}

// React hook for language — triggers re-render on change
export function useLang() {
  const { useState, useEffect, useCallback } = require("react");
  const [lang, setLangState] = useState(getLang());
  useEffect(() => {
    const handler = () => setLangState(getLang());
    window.addEventListener("ade-lang-change", handler);
    return () => window.removeEventListener("ade-lang-change", handler);
  }, []);

  const translate = useCallback((key) => {
    return translations[lang]?.[key] || translations.en[key] || translations.it[key] || key;
  }, [lang]);

  return { lang, t: translate };
}

export default translations;
